<template>
  <div>
    <Header
      @changeInterval="changeInterval"
      @changeType="changeViewType"
      :type="type"
    />
    <a-card :bordered="false" class="statistics__main">
      <a-row :gutter="16">
        <a-col
          class="gutter-row"
          :md="24"
          :lg="24"
          :xl="10"
          :xxl="10"
          style="display: flex;"
        >
          <a-select v-model="filterOption.categoryType">
            <a-select-option value="allow">允许</a-select-option>
            <a-select-option value="exclude">排除</a-select-option>
          </a-select>
          <a-select
            mode="multiple"
            placeholder="选择分类，为空则不设置过滤"
            :value="queryParam.categorys"
            style="width: 100%"
            @change="filterCategorys"
          >
            <a-select-option
              v-for="item in filteredCategorys"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-col>
        <a-col
          class="gutter-row"
          :md="24"
          :lg="24"
          :xl="2"
          :xxl="2"
          style="display: flex;"
        >
          <a-select v-model="filterOption.operation" style="width:100%;">
            <a-select-option value="intersection">同时（交集）</a-select-option>
            <a-select-option value="union">或者（并集）</a-select-option>
          </a-select>
        </a-col>
        <a-col
          class="gutter-row"
          :md="24"
          :lg="24"
          :xl="10"
          :xxl="10"
          style="display: flex;"
        >
          <a-select v-model="filterOption.eventType">
            <a-select-option value="allow">允许</a-select-option>
            <a-select-option value="exclude">排除</a-select-option>
          </a-select>
          <a-select
            mode="multiple"
            placeholder="选择事件，为空则不设置过滤"
            :value="queryParam.events"
            style="width: 100%"
            @search="handleSearch"
            @change="filterEvents"
          >
            <a-select-option
              v-for="item in filteredEvents"
              :key="item.id"
              :value="item.name"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-col>
        <a-col :md="24" :lg="24" :xl="2" :xxl="2"
          ><a-button type="primary" style="width:100%;" @click="initData"
            >过滤</a-button
          ></a-col
        >
      </a-row>
    </a-card>
    <a-spin :spinning="spinning" class="statistics__loading">
      <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
    </a-spin>

    <a-result
      v-if="!hasData && !spinning"
      title="没有数据"
      sub-title="请到块页面记录事件或，点击右上角切换统计日期范围和统计类型"
    >
      <template #icon>
        <a-icon type="frown" theme="twoTone" />
      </template>
    </a-result>

    <a-row v-show="hasData && !spinning" :gutter="16">
      <a-card title="汇总" :bordered="false" class="statistics__main">
        <a-col class="gutter-row" :md="24" :lg="24" :xl="15" :xxl="15">
          <a-spin :spinning="loading.column">
            <div ref="StackedColumn"></div>
          </a-spin>
        </a-col>
        <a-col class="gutter-row" :md="24" :lg="24" :xl="9" :xxl="9">
          <a-spin :spinning="loading.donut">
            <div ref="donut"></div>
          </a-spin>
        </a-col>
      </a-card>
    </a-row>
    <a-row v-show="hasData && !spinning" :gutter="16">
      <a-col :md="24" :lg="24" :xl="15" :xxl="16">
        <a-card title="趋势" :bordered="false" class="statistics__main">
          <a-spin :spinning="loading.line">
            <div ref="line"></div>
          </a-spin>
        </a-card>
      </a-col>
      <a-col :md="24" :lg="24" :xl="9" :xxl="8">
        <a-card title="分类数据对比" :bordered="false" class="statistics__main">
          <a-spin :spinning="loading.stack">
            <div ref="stackDate"></div>
          </a-spin>
        </a-card>
      </a-col>
    </a-row>
    <!-- <a-card
      v-show="hasData && !spinning"
      title="详情"
      :bordered="false"
      class="statistics__main"
    >
      <StatisticsTable :logs="logs" />
    </a-card> -->
  </div>
</template>

<script>
//TODO 算法优化
import Header from "./components/StatisticsHeader.vue";
// import StatisticsTable from "./components/StatisticsTable";
import StatisticsPlot from "./mixins/StatisticsPlot";
import StatisticsFilterBar from "./mixins/StatisticsFilterBar";
import StatisticsFilter from "./mixins/StatisticsFilter";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

const weekOfday = moment().format("E");
const lastMonday = moment()
  .subtract(weekOfday - 1, "days")
  .format("YYYY-MM-DD"); //周一日期
const toDay = moment().format("YYYY-MM-DD");

window.moment = moment;
console.log(lastMonday);

export default {
  mixins: [StatisticsPlot, StatisticsFilterBar, StatisticsFilter],
  components: {
    Header
    // StatisticsTable
  },
  data() {
    return {
      type: "category",
      start: moment(lastMonday, "YYYY-MM-DD").valueOf(),
      end: moment(toDay, "YYYY-MM-DD").valueOf(),
      hasData: false,
      spinning: false,
      logs: {}
    };
  },
  computed: {
    ...mapGetters(["categorys", "events"])
  },
  mounted() {
    this.initData();
  },
  methods: {
    moment,
    async initData() {
      this.spinning = true;
      await this.getLogs();
      await this.getPlotData();
      this.judgeData();
    },
    async getLogs() {
      //获取显示日期范围的日志
      const logs = {};

      for (let day = this.start; day <= this.end; day += 24 * 60 * 60 * 1000) {
        //获取一天的记录
        const log = await this.getLogByDay(day);
        if (!log) continue; //过滤空日志

        //过滤被删除的事件或记录
        logs[day] = log.filter(record => this.filterRecordTest(record));
      }

      this.logs = logs;
    },

    changeInterval({ start, end }) {
      //改变显示日期区间
      this.start = start.valueOf();
      this.end = end.valueOf();
      this.initData();
    },
    changeViewType(type) {
      //修改统计视图
      this.type = type;
    },
    judgeData() {
      //判断是否存在记录
      const data = this.plotData;
      this.spinning = false;

      for (let key in data) {
        if (!data[key] || data[key].length === 0) {
          this.hasData = false;
          return;
        }
      }

      this.hasData = true;
    },
    ...mapActions(["getLogByDay"])
  }
};
</script>

<style>
.statistics__main {
  margin: 2rem;
}

.statistics__loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
